// Hubspot Conversations Chat
// https://developers.hubspot.com/docs/api/conversation/chat-widget-sdk
function onConversationsAPIReady() {
  window.HubSpotConversations.widget.load();
}

function HubspotForm({ userSelections, userCalculations }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);

    /*
      If external API methods are already available, use them.
    */
    if (window.HubSpotConversations) {
      onConversationsAPIReady();
    } else {
      /*
        Otherwise, callback will be called once the external API has been initialized.
      */
      window.hsConversationsOnReady = [onConversationsAPIReady];
    }

    function initHubspotForm() {
      if (hbspt) {
        hbspt.forms.create({
          region: "na1",
          portalId: "6634526",
          formId: "d0dd5804-70e0-48d5-8e53-ef0e96dfd8eb",
          target: "#hubspotForm",
          onFormReady: function () {
            $('input[name="cct_people_needing_coverage"]').val(userSelections["people"]).change();
            $('input[name="cct_age_over_65"]')
              .val(userSelections["age_over_65"] === "yes")
              .change();
            $('input[name="cct_healthcare_solution"]').val(userSelections["solution"]).change();
            $('input[name="cct_risk_tolerance"]').val(userSelections["risk_tolerance"]).change();
            $('input[name="cct_primary_recommended_program"]').val(userCalculations["recommended_program"]).change();
            $('input[name="cct_alternative_program"]').val(userCalculations["alternative_program"]).change();
            $('input[name="cct_annual_personal_cost"]').val(userCalculations["annual_personal_costs"]).change();
            $('input[name="cct_primary_program_annual_cost"]')
              .val(userCalculations["annual_recommended_program_costs"])
              .change();
            $('input[name="cct_primary_program_annual_savings"]')
              .val(userCalculations["recommended_program_total_annual_savings"])
              .change();
            $('input[name="cct_alternative_program_annual_cost"]')
              .val(userCalculations["annual_alternative_program_costs"])
              .change();
            $('input[name="cct_alternative_program_annual_savings"]')
              .val(userCalculations["alternative_program_total_annual_savings"])
              .change();
          },
        });
      }
    }

    script.addEventListener("load", initHubspotForm);

    return () => {
      script.removeEventListener("load", initHubspotForm);
    };
  }, []);

  // calculate costs and savings, update Hubspot form fields
  useEffect(() => {
    $('input[name="cct_annual_personal_cost"]').val(userCalculations["annual_personal_costs"]).change();
    $('input[name="cct_primary_program_annual_cost"]')
      .val(userCalculations["annual_recommended_program_costs"])
      .change();
    $('input[name="cct_primary_program_annual_savings"]')
      .val(userCalculations["recommended_program_total_annual_savings"])
      .change();
    $('input[name="cct_alternative_program_annual_cost"]')
      .val(userCalculations["annual_alternative_program_costs"])
      .change();
    $('input[name="cct_alternative_program_annual_savings"]')
      .val(userCalculations["alternative_program_total_annual_savings"])
      .change();
  }, [userCalculations]);
}
